'use client';
import { LicenseInfo } from '@mui/x-license';
const key = import.meta.env.VITE_MUI_LICENSE_KEY;
LicenseInfo.setLicenseKey(key);


export default function MuiXLicense() {
  return null;
}
